import type { PickAnalyticsEventAttributes } from '../../../../types'
import { analyticsEvents } from '../../integration/analytics-multiplatform-sdk'

export const AuthenticationOptionsScreen = (
  attributes: PickAnalyticsEventAttributes<'AuthenticationOptionsScreen'>
) => {
  const { AuthenticationOptionsScreen, AuthenticationOption } = analyticsEvents

  const authenticationOptions = attributes.options.map(
    (option) => AuthenticationOption[option as keyof typeof AuthenticationOption]
  )

  return new AuthenticationOptionsScreen(attributes.isNewUser, authenticationOptions)
}

export const CreatePassword = () => {
  const { CreatePassword } = analyticsEvents
  return new CreatePassword()
}

export const EnterEmailScreen = (attributes: PickAnalyticsEventAttributes<'EnterEmailScreen'>) => {
  const { EnterEmailScreen, EnterEmailOrigin } = analyticsEvents
  return new EnterEmailScreen(EnterEmailOrigin[attributes.enterEmailOrigin])
}

export const EnterPassword = () => {
  const { EnterPassword } = analyticsEvents
  return new EnterPassword()
}

export const ForgotPassword = () => {
  const { ForgotPassword } = analyticsEvents
  return new ForgotPassword()
}

export const InvalidEmail = () => {
  const { InvalidEmail } = analyticsEvents
  return new InvalidEmail()
}

export const PrivacyReview = () => {
  const { PrivacyReview } = analyticsEvents
  return new PrivacyReview()
}

export const ResetPasswordError = (
  attributes: PickAnalyticsEventAttributes<'ResetPasswordError'>
) => {
  const { ResetPasswordError } = analyticsEvents

  return new ResetPasswordError(attributes.resetErrorMessage)
}

export const ResetPassword = () => {
  const { ResetPassword } = analyticsEvents
  return new ResetPassword()
}

export const ResetYourAccountStarted = (
  attributes: PickAnalyticsEventAttributes<'ResetYourAccountStarted'>
) => {
  const { ResetYourAccountStarted } = analyticsEvents
  return new ResetYourAccountStarted(attributes.phone)
}

export const SignInLanding = (attributes: PickAnalyticsEventAttributes<'SignInLanding'>) => {
  const { SignInLanding, SignInLandingOrigin } = analyticsEvents

  return new SignInLanding(SignInLandingOrigin[attributes.signInLandingOrigin])
}

export const SignUpError = (attributes: PickAnalyticsEventAttributes<'SignUpError'>) => {
  const { SignUpError } = analyticsEvents

  return new SignUpError(attributes.signUpErrorMessage)
}

export const TellUsYourName = () => {
  const { TellUsYourName } = analyticsEvents
  return new TellUsYourName()
}

export const UserLoggedIn = (attributes: PickAnalyticsEventAttributes<'UserLoggedIn'>) => {
  const { UserLoggedIn, UserRegistrationType } = analyticsEvents

  return new UserLoggedIn(
    UserRegistrationType[attributes.userRegistrationType],
    attributes.isNewUser
  )
}

export const UserSignedUp = (attributes: PickAnalyticsEventAttributes<'UserSignedUp'>) => {
  const { UserSignedUp, UserRegistrationType } = analyticsEvents

  return new UserSignedUp(UserRegistrationType[attributes.userRegistrationType])
}

export const WrongCredentials = () => {
  const { WrongCredentials } = analyticsEvents
  return new WrongCredentials()
}
